/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteBookmark.defs.js'
export { main as default } from './deleteBookmark.defs.js'
